import { ValueFormatterParams } from 'ag-grid-community';

export const currencyFormatter = (params: ValueFormatterParams) => {
    if (!params?.value) return '';
    return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
    }).format(params.value);
};
